export default {"src":"/_next/static/media/lead-contactH.e065aa1e.svg","height":56,"width":864};